import { render, staticRenderFns } from "./UploadFundingAttachment.vue?vue&type=template&id=d04eb860"
import script from "./UploadFundingAttachment.vue?vue&type=script&lang=js"
export * from "./UploadFundingAttachment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports